import Api from '@/api/config/_api_config.js'

export default {

    updateActiveRole(userId, roleId){
        const promise = Api().get('/users/'+userId+'/update_active_role?role_id='+roleId);

        return promise.then((response) => response.data)
    },

    getMinimalUsersInfo(){
        const promise = Api().get('users/minimalist')

        return promise.then((response) => response.data)
    },

    getAuthUser(user_id){
        const promise = Api().get('users/'+user_id)
        return promise.then((response) => response.data)
    },

    login(data) {
        const promise = Api().post('/login', data)
        return promise.then((response) => response.data)
    },

    getAdminUsers() {
        const promise = Api().get('/config/admin-users')
        return promise.then((response) => response.data)
    },

    getCouponAuthorizedUsers() {
        const promise = Api().get('/config/coupon/authorized-users')
        return promise.then((response) => response.data)
    },

    saveCouponAuthorizedUsers(data) {
        const promise = Api().post('/config/coupon/set-authorized-users', data)
        return promise.then((response) => response.data)
    },
}